import CheckUpload from './check-upload';

export default CheckUpload;
